class MexicoArtLightboxGallery extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.dialog = this.querySelector("[data-ma-lightbox-dialog]");
    this.image = this.querySelector("[data-ma-lightbox-image]");
    this.captionEl = this.querySelector("[data-ma-lightbox-caption]");
    this.metaEl = this.querySelector("[data-ma-lightbox-meta]");
    this.counterEl = this.querySelector("[data-ma-lightbox-counter]");
    this.linkEl = this.querySelector("[data-ma-lightbox-link]");
    this.closeButton = this.querySelector("[data-ma-lightbox-close]");
    this.prevButton = this.querySelector("[data-ma-lightbox-prev]");
    this.nextButton = this.querySelector("[data-ma-lightbox-next]");
    this.triggers = [...this.querySelectorAll("[data-ma-lightbox-trigger]")];

    if (!this.dialog || !this.image || this.triggers.length === 0) return;

    this.counterTemplate = this.dataset.counterLabel || "{current} / {total}";
    this.currentIndex = 0;
    this.lastFocused = null;

    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener("click", () => this.open(index));
    });

    this.closeButton?.addEventListener("click", () => this.close());
    this.prevButton?.addEventListener("click", () => this.step(-1));
    this.nextButton?.addEventListener("click", () => this.step(1));

    this.dialog.addEventListener("click", (event) => {
      if (event.target === this.dialog) this.close();
    });

    this.dialog.addEventListener("cancel", (event) => {
      event.preventDefault();
      this.close();
    });

    this.handleKeydown = (event) => {
      if (!this.dialog.open) return;
      if (event.key === "ArrowRight") {
        event.preventDefault();
        this.step(1);
      } else if (event.key === "ArrowLeft") {
        event.preventDefault();
        this.step(-1);
      } else if (event.key === "Escape") {
        event.preventDefault();
        this.close();
      }
    };
  }

  open(index) {
    if (!this.dialog) return;
    this.lastFocused = document.activeElement;
    this.currentIndex = index;
    this.render();

    if (typeof this.dialog.showModal === "function") {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute("open", "");
    }

    document.addEventListener("keydown", this.handleKeydown);
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    if (!this.dialog) return;
    if (this.dialog.open && typeof this.dialog.close === "function") {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute("open");
    }

    document.removeEventListener("keydown", this.handleKeydown);
    document.documentElement.style.overflow = "";

    if (this.lastFocused && typeof this.lastFocused.focus === "function") {
      this.lastFocused.focus();
    }
  }

  step(direction) {
    if (this.triggers.length === 0) return;
    const total = this.triggers.length;
    this.currentIndex = (this.currentIndex + direction + total) % total;
    this.render();
  }

  render() {
    const trigger = this.triggers[this.currentIndex];
    if (!trigger) return;

    const fullSrc =
      trigger.dataset.fullSrc || trigger.querySelector("img")?.src || "";
    const fullSrcset = trigger.dataset.fullSrcset || "";
    const caption = trigger.dataset.caption || "";
    const meta = trigger.dataset.meta || "";
    const link = trigger.dataset.href || "";

    this.image.setAttribute("src", fullSrc);
    if (fullSrcset) {
      this.image.setAttribute("srcset", fullSrcset);
      this.image.setAttribute("sizes", "100vw");
    } else {
      this.image.removeAttribute("srcset");
      this.image.removeAttribute("sizes");
    }
    this.image.setAttribute("alt", caption);

    if (this.captionEl) this.captionEl.textContent = caption;
    if (this.metaEl) this.metaEl.textContent = meta;
    if (this.counterEl) {
      this.counterEl.textContent = this.counterTemplate
        .replace("{current}", String(this.currentIndex + 1))
        .replace("{total}", String(this.triggers.length));
    }
    if (this.linkEl) {
      if (link) {
        this.linkEl.href = link;
        this.linkEl.hidden = false;
      } else {
        this.linkEl.hidden = true;
        this.linkEl.removeAttribute("href");
      }
    }
  }
}

if (!customElements.get("ma-lightbox-gallery")) {
  customElements.define("ma-lightbox-gallery", MexicoArtLightboxGallery);
}
